<template>
  <a
    :target="shouldOpenInNewTab"
    :href="url"
    class="backup-learn-more-link"
    :class="appearanceClass"
    >{{ text }}</a
  >
</template>

<script>
export default {
  name: 'IncrediLink',
  props: {
    url: {
      type: String,
      required: true,
    },
    appearanceClass: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      required: true,
    },
    openInNewTab: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    shouldOpenInNewTab() {
      return this.openInNewTab ? '_blank' : '_self';
    },
  },
};
</script>

<style lang="scss" scoped>
.backup-learn-more-link {
  @apply text-Text/text_primary font-gordita-medium no-underline hover:underline;
}
</style>
